import React, { useContext, useMemo } from 'react';
import { TagProps } from 'antd';
import SessionContext from '@providers/Session/SessionContext';

import * as S from './styles';

export type TagColors = 'green' | 'orange' | 'yellow' | 'red' | 'blue';
export type TagTypes = 'default' | 'solid';

interface CustomTagProps extends TagProps {
  color?: TagColors;
  type?: TagTypes;
}

const CustomTag = ({
  children,
  color,
  type = 'default',
  ...props
}: CustomTagProps) => {
  const { theme } = useContext(SessionContext);

  const tagColor = useMemo(
    () => color && theme?.colors?.[color],
    [color, theme?.colors],
  );

  return (
    <S.CustomTagContainer
      className={`custom-tag-${type === 'default' ? 'default' : 'solid'}`}
      type={type}
      color={tagColor}
      theme={theme}
      {...props}
    >
      {children}
    </S.CustomTagContainer>
  );
};

export default CustomTag;
